import {
  Button,
  Div,
  HeaderBack,
  ImageView,
  Label,
  LoadingIndicator,
} from 'components';
import {Ecolors, Efonts, Icons, urlApp} from 'constant';
import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {
  getInvestmentProfile,
  getStatusEditProfile,
} from 'reducer/authen/selector';
import {navigate, useImageUrl} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {
  convertTimestamp,
  parseMultilanguage,
  widthScale,
  widthScreen,
} from 'utils';
import {getStoreToken} from 'utils/storage';
import {useDispatch} from 'react-redux';
import {convertchangeIdNoStatus} from '../ChangeCMNDtoCCCDScreen/api';
import {getInfo} from 'reducer/authen';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      height={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.spaceColor}
      paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function AccountInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const dispatch = useAppDispatch();
  const [country, setCountry] = useState<any>(null);
  const isEdit = useAppSelector(state => getStatusEditProfile(state));
  const {
    email,
    phone,
    name,
    gender,
    dob,
    idTypeId,
    idNo,
    dateOfIssue,
    placeOfIssue,
    mailingCountryId,
    nationalityId,
    userPhotos,
    changeIdNoStatus,
    changeIdNo,
  } = currentUser;

  const [frontCard, frontLoading] = useImageUrl(
    `download/file-for-link`,
    'POST',
    `${userPhotos?.[0]?.url || ''}`,
  );

  const [backCard, backLoading] = useImageUrl(
    `download/file-for-link`,
    'POST',
    `${userPhotos?.[1]?.url || ''}`,
  );

  useEffect(() => {
    getCountry();
    dispatch(getInfo({}));
    return () => {};
  }, []);

  const getCountry = async () => {
    try {
      const res = await apiMain.getCountry();
      const c = res.data.find(
        (a: any) => a.id == mailingCountryId || a.id == nationalityId,
      );
      if (c) {
        setCountry(c);
      }
    } catch (error) {}
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={isEdit ? Icons.edit : changeIdNo == 1 ? Icons.edit : null}
        loading={frontLoading || backLoading}
        title={`accountverify.thongtincanhan`}
        onRightPress={() => {
          if (frontLoading || backLoading) {
            return;
          }
          if (changeIdNo == 1) {
            navigate('ControlCMNDScreen');
            return;
          }
          navigate('EditAccountInfoModal');
        }}
      />
      <ScrollView>
        {!!changeIdNoStatus && (
          <Button
            onPress={() => {
              navigate('ChangeCMNDtoCCCDDetailsScreen', {change: 'cccd'});
            }}>
            <RowSpaceItem>
              <Label>{`changecmnd.trangthaihoso`}</Label>
              <Div
                flexDirection="row"
                alignItems="center"
                justifyContent="flex-end">
                <Label
                  style={{fontStyle: 'italic'}}
                  color={convertchangeIdNoStatus(changeIdNoStatus).color}
                  multilanguage={false}>
                  {convertchangeIdNoStatus(changeIdNoStatus).title}
                </Label>
                <ImageView
                  marginLeft={5}
                  widthHeight={12}
                  source={Icons.forward}
                  resizeMode="contain"
                />
              </Div>
            </RowSpaceItem>
          </Button>
        )}
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtinnhadautu`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.hoten`}</Label>
          <Label multilanguage={false}>{name}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.gioitinh`}</Label>
          <Label>
            {gender === 1 ? `accountverify.nam` : `accountverify.nu`}
          </Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaysinh`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dob)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.quoctich`}</Label>
          <Label multilanguage={false}>{country?.name || ''}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.email`}</Label>
          <Label multilanguage={false}>{email}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sodienthoai`}</Label>
          <Label multilanguage={false}>{phone}</Label>
        </RowSpaceItem>
        {/*  */}
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtincmnd`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.loaigiayto`}</Label>
          <Label multilanguage={!!idTypeId}>
            {(idTypeId &&
              (idTypeId == 1
                ? `accountverify.cccd`
                : `accountverify.magiaodichchungkhoan`)) ||
              ''}
          </Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sohieugiayto`}</Label>
          <Label multilanguage={false}>{idNo}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaycap`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dateOfIssue)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.noicap`}</Label>

          <Label
            style={{paddingLeft: 10, textAlign: 'right', flex: 1}}
            multilanguage={false}>
            {placeOfIssue}
          </Label>
        </RowSpaceItem>
        {(frontLoading || backLoading) && (
          <Div alignItems={'center'} paddingTop={10} justifyContent={'center'}>
            <LoadingIndicator color={Ecolors.mainColor} numdot={3} />
          </Div>
        )}
        <Div
          padding={16}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          {[frontCard, backCard].map((item, index) => (
            <Div
              key={index}
              width={162}
              height={103}
              overflow="hidden"
              borderRadius={5}
              borderWidth={1}
              borderColor={Ecolors.bordercolor}>
              <ImageView
                width={162}
                height={103}
                source={{uri: item?.url || ''}}
              />
            </Div>
          ))}
        </Div>
        {changeIdNo != 1 && !isEdit && (
          <Div
            flexWrap={'wrap'}
            flexDirection={'row'}
            padding={16}
            paddingTop={0}>
            <Label multilanguage={false} size={14}>
              <Label
                fontWeight={'bold'}
                size={14}>{`accountverify.luuy`}</Label>
              {parseMultilanguage(`accountverify.contentdoicmnd`)}
            </Label>
          </Div>
        )}

        <Div height={200} />
      </ScrollView>
    </Div>
  );
}

const s = StyleSheet.create({
  imgContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: widthScale(200),
  },
  sbutton: {
    width: widthScreen - widthScale(30),
    height: widthScale(200),
  },
});

export default React.memo(AccountInfoModal);
